export default __webpack_public_path__ + "static/1072-8ac5dd31b6f31ff056cf4ef28597f14a.gif";